import { useEffect } from 'react';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useGeolocation from '@webclient/hooks/useGeoLocation';

import { setUserGeoLocation } from '@webclient/state/slices/app-settings';

type Props = {
  children: React.ReactNode;
};

export default function GeolocationDispatcher({ children }: Props) {
  const dispatch = useAppDispatch();
  const { position } = useGeolocation();

  //TODO: better to have all business logic in redux since we are using redux, todo: asyncThunks can be useful
  useEffect(() => {
    dispatch(setUserGeoLocation(position));
  }, [dispatch, position]);

  return children;
}
